<!--
 * @Author: 史金波
 * @Date: 2021-12-15 03:11:24
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 13:21:02
 * @FilePath: \saas-perform-web\src\views\dashboad.vue
-->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/dashboad' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>控制台</el-breadcrumb-item>
		</el-breadcrumb>
    <el-row :gutter="20" class="title_card">
      <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="clearfix title_header">
            <div class="title_text">
              押金
            </div>
            <div class="title_amount">
               {{parseFloat(accountInfo.depositAmount/100).toFixed(2)}}元
            </div>
          </div>
          <div style="text-align:center;">
							
					</div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="clearfix title_header">
            <div class="title_text">
              近30日核销
            </div>
            <div class="title_amount">
               {{accountInfo.writeOffAmount}}元
            </div>
          </div>
        </el-card>
        <div style="text-align:center;">
							
					</div>
      </el-col>
      <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="clearfix title_header">
            <div class="title_text">
              近30天退款
            </div>
            <div class="title_amount">
               {{accountInfo.refundAmount}}元
            </div>
          </div>
        </el-card>
      </el-col>
      
    </el-row>
    <el-row :gutter="20" style="margin-top: 4.0rem;">
    <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="clearfix title_header">
            <div class="title_text">
              预付款剩余
            </div>
            <div class="title_amount">
               {{accountInfo.advanceChargeAmount}}元
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="clearfix title_header">
            <div class="title_text">
              近30天核销
            </div>
            <div class="title_amount">
               {{accountInfo.writeOffNum}}笔
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="clearfix title_header">
            <div class="title_text">
              进30日退款
            </div>
            <div class="title_amount">
               {{accountInfo.refundNum}}笔
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {searchAccountAmountInfo} from "../api/recharge/rechargeApi"
export default {
  data(){
    return {
      accountInfo:{
        advanceChargeAmount:0,
        depositAmount:0,
        writeOffAmount:0,
        writeOffNum:0,
        refundAmount:0,
        refundNum:0
      }
    }
  },
  created(){
    searchAccountAmountInfo().then(res=>{
      if(res.data.code = '000000'){
        this.accountInfo = res.data.data
      }
    })
  }
}
</script>
<style>
  .title_text {
    font-size: 0.3rem;
  }

  .title_amount {
    font-size: 1.7rem;
  }

  .title_card {
    margin-top: 4.0rem;
  }

  .title_header {
    margin: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboad.vue